import CobranzaUpdate from './CobranzaUpdate'
export {CobranzaUpdate}
export default CobranzaUpdate
